import { Card as AntdCard, CardProps } from 'antd';
import cx from 'classnames';

export const Card = (props: CardProps) => {
  const { className, ...rest } = props;

  return <AntdCard className={cx(className, 'rounded-default')} {...rest} />;
};
